Vue.component('giveKey', {
  template: templates.giveKey,
  data() {
    return {
      model: {
        keyId: null,
        keys: {},
        searchResults: []
      }
    }
  },
  mounted() {
    const c = this;
    c.$root.$on('getKeys', keys => {
      c.model.keys = keys;
    });
  },
  methods: {
    searchUsers() {
      const c = this;
      let names = [];
      const twitchDisplayName = $('[name="key-user"]').val();

      userService.search({twitchDisplayName: twitchDisplayName})
        .then(function (response) {
          c.model.searchResults = response.data;
          for (let data of response.data) {
            names.push(data.twitchDisplayName);
          }
          
          $('[name="key-user"]').autocomplete({
            source: names
          });
        })
        .catch(function (error) {
        
        });
    },
    getUserId(twitchDisplayName, callback) {
      const c = this;
      for (let user of c.model.searchResults) {
        if (user.twitchDisplayName == twitchDisplayName) {
          callback(user.twitchId);
          return;
        }
      }

      twitchAPI.getUserByLogin(twitchDisplayName, function(userData) {

        for (let data of userData) {
          callback(data.id);
          return;
        }
        
        callback(null);

      });
    },
    save() {
      const c = this;
      const twitchDisplayName = $('[name="key-user"]').val();

      c.getUserId(twitchDisplayName, function(twitchId) {

        if (!twitchId || !c.model.keyId) {
          utils.alert.error('User and key required!');
          return;
        }

        const data = {
          twitchId: twitchId,
          keyId: c.model.keyId
        }

        keyService.unlock(data)
          .then(function (response) {
            c.reset();
          })
          .catch(function (error) {
            //console.log(error);
          });

      });
    },
    reset() {
      const c = this;
      $('[name="key-user"]').val('');
      c.model.keyId = null;
    }
  }
});